module.exports = __webpack_public_path__ + "static/media/no-img.d8600263.png";